var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Anchor } from '@atlassiansox/bxp-content-framework';
import { RightArrow, Play } from '../icons';
import { BxpButton, BxpLink, getAppearance, getSpacing, getProminence } from './link-button.styles';
export function LinkButton(_a) {
    var { appearance, style, children, decorator, id, isBlock, prominence, onClick, spacing, url, testId, tabIndex } = _a, rest = __rest(_a, ["appearance", "style", "children", "decorator", "id", "isBlock", "prominence", "onClick", "spacing", "url", "testId", "tabIndex"]);
    const buttonText = (_jsxs(_Fragment, { children: [_jsx("span", { children: children }, void 0), decorator === 'Arrow' && _jsx(RightArrow, {}, void 0), decorator === 'Play' && _jsx(Play, {}, void 0)] }, void 0));
    const wrapperProps = {
        bxpAppearance: getAppearance(appearance, style),
        bxpProminence: getProminence(prominence, style),
        bxpSpacing: getSpacing(spacing),
        bxpIsBlock: isBlock
    };
    const elementProps = Object.assign({ id,
        onClick,
        tabIndex }, rest);
    return onClick && !url ? (_jsx(BxpButton, Object.assign({}, wrapperProps, { children: _jsx("button", Object.assign({}, elementProps, { "data-testid": testId, type: "button" }, { children: buttonText }), void 0) }), void 0)) : (_jsx(BxpLink, Object.assign({}, wrapperProps, { children: _jsx(Anchor, Object.assign({}, elementProps, { href: url, testId: testId }, { children: buttonText }), void 0) }), void 0));
}
//# sourceMappingURL=link-button.js.map